module.exports = __webpack_public_path__ + "static/img/main.b9d21352.png";